import { categories } from '@/mocks/categories';

export default function Footer() {
  const quickLinks = [
    { label: 'Home', href: '/' },
    { label: 'CSSBuy Sheet Guide', href: '/cssbuy-sheet-guide' },
    { label: 'Shipping Guide', href: '/guides/shipping' },
    { label: 'QC Guide', href: '/guides/qc' },
    { label: 'FAQ', href: '/#faq' },
  ];

  const brandLinks = [
    { label: 'Nike Spreadsheet', href: '/brands/nike' },
    { label: 'Adidas Spreadsheet', href: '/brands/adidas' },
    { label: 'Supreme Spreadsheet', href: '/brands/supreme' },
  ];

  const comparisonLinks = [
    { label: 'CSSBuy vs Kakobuy', href: '/comparison/cssbuy-vs-kakobuy' },
    { label: 'CSSBuy vs Superbuy', href: '/comparison/cssbuy-vs-superbuy' },
    { label: 'Kakobuy vs Superbuy', href: '/comparison/kakobuy-vs-superbuy' },
  ];

  const agentLinks = [
    { label: 'Kakobuy Spreadsheet', href: '/kakobuy-spreadsheet' },
    { label: 'Superbuy Spreadsheet', href: '/superbuy-spreadsheet' },
    { label: 'Oopbuy Spreadsheet', href: '/oopbuy-spreadsheet' },
    { label: 'CSSBuy Sheet (Main)', href: 'https://kaspreadsheet.com' },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-stack-line text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-lg font-semibold text-foreground-900">
                  CSSSpreadsheet
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                The most comprehensive spreadsheet directory for CSSBuy, Kakobuy, Superbuy, Oopbuy and trusted shopping agent resources.
              </p>
              <div className="flex items-center gap-3">
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full bg-background-200 flex items-center justify-center hover:bg-primary-100 transition-colors cursor-pointer">
                  <i className="ri-external-link-line text-foreground-600 text-sm"></i>
                </a>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full bg-background-200 flex items-center justify-center hover:bg-primary-100 transition-colors cursor-pointer">
                  <i className="ri-shopping-bag-line text-foreground-600 text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-label text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-5">Quick Links</h4>
              <ul className="space-y-3">
                {quickLinks.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-label text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-5">Brands</h4>
              <ul className="space-y-3">
                {brandLinks.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
              <h4 className="font-label text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-5 mt-6">Comparisons</h4>
              <ul className="space-y-3">
                {comparisonLinks.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-label text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-5">Agent Hubs</h4>
              <ul className="space-y-3">
                {agentLinks.map((link) => {
                  const isExternal = link.href.startsWith('http');
                  return (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        target={isExternal ? '_blank' : undefined}
                        rel={isExternal ? 'noopener nofollow' : undefined}
                        className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                      >
                        {link.label}
                      </a>
                    </li>
                  );
                })}
              </ul>
              <h4 className="font-label text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-5 mt-6">Top Categories</h4>
              <ul className="space-y-3">
                {categories.slice(0, 4).map((cat) => (
                  <li key={cat.name}>
                    <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-200/70">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-500">
                &copy; 2026 CSSSpreadsheet.cam. All rights reserved.
              </p>
              <div className="flex items-center gap-4">
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">
                  Main Site
                </a>
                <span className="text-foreground-300 text-xs">|</span>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">
                  Privacy
                </a>
                <span className="text-foreground-300 text-xs">|</span>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">
                  Terms
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}